import session from './session';
import axios from 'axios';
import ErrorMessages from './error-messages';
import moment from 'moment';

const apiPath = '/api/v1/';
const apiV2Path = '/api/v2/';

const API_AUTH_HEADER = 'X-Finch';

const API_ENDPOINT_V1_VERSION                               = '/api/v1/version';
const API_ENDPOINT_V1_DOC_SENTIMENT                         = '/api/v1/doc-sentiment';
const API_ENDPOINT_V1_TRIT_SENTIMENT                        = '/api/v1/trit-sentiment';
const API_ENDPOINT_V1_CONVERT_DOC                           = '/api/v1/convert-doc';
const API_ENDPOINT_V2_CONVERT_DOC                           = '/api/v2/convert-doc';
const API_ENDPOINT_V1_IE_PROMPTS                            = '/api/v1/information-extraction-prompts';
const API_ENDPOINT_V1_CORRECT_TEXT                          = '/api/v1/correct-text';
const API_ENDPOINT_V1_DETECT_LANGUAGE                       = '/api/v1/detect-language';
const API_ENDPOINT_V1_DETECT_LANGUAGES                      = '/api/v1/detect-languages';
const API_ENDPOINT_V2_DETECT_LANGUAGE                       = '/api/v2/detect-language';
const API_ENDPOINT_V2_DETECT_LANGUAGES                      = '/api/v2/detect-languages';
const API_ENDPOINT_V1_LOCATION_FINDER                       = '/api/v1/location-finder';
const API_ENDPOINT_V1_INFORMATION_EXTRACTION_PROMPTS        = '/api/v1/information-extraction-prompts';
const API_ENDPOINT_V1_EXTRACTION                            = '/api/v1/extraction';
const API_ENDPOINT_V1_EXTRACTION_INSERT                     = '/api/v1/extraction/insert';
const API_ENDPOINT_V1_EXTRACTION_VALIDATE                   = '/api/v1/extraction/validate';
const API_ENDPOINT_V1_EXTRACTION_DELETE                     = '/api/v1/extraction/delete';
const API_ENDPOINT_V1_EXTRACTION_DELETE_ALL                 = '/api/v1/extraction/delete-all';
const API_ENDPOINT_V1_EXTRACTION_RETRIEVE                   = '/api/v1/extraction/retrieve';
const API_ENDPOINT_V1_REGEX                                 = '/api/v1/regex';
const API_ENDPOINT_V1_REGEX_INSERT                          = '/api/v1/regex/insert';
const API_ENDPOINT_V1_REGEX_VALIDATE                        = '/api/v1/regex/validate';
const API_ENDPOINT_V1_REGEX_DELETE                          = '/api/v1/regex/delete';
const API_ENDPOINT_V1_REGEX_DELETE_ALL                      = '/api/v1/regex/delete-all';
const API_ENDPOINT_V1_REGEX_RETRIEVE                        = '/api/v1/regex/retrieve';
const API_ENDPOINT_V1_QUERY_PARSER                          = '/api/v1/query-parser';
const API_ENDPOINT_V1_SUMMARIZE                             = '/api/v1/summarize';
const API_ENDPOINT_V1_USERINFO                              = '/api/v1/userinfo';
const API_ENDPOINT_V1_INTEREST_AREAS                        = '/api/v1/interest-areas';
const API_ENDPOINT_V1_USAGE                                 = '/api/v1/usage';
const API_ENDPOINT_V1_TRANSLATE                             = '/api/v1/translate';
const API_ENDPOINT_V2_ENRICH                                = '/api/v2/enrich';
const API_ENDPOINT_V2_ENTITIES                              = '/api/v2/entities';
const API_ENDPOINT_V1_ADMIN_HEALTH                          = '/api/v1/admin/health';
const API_ENDPOINT_V1_ADMIN_SYSINFO                         = '/api/v1/admin/sysinfo';
const API_ENDPOINT_V1_ADMIN_RESTART                         = '/api/v1/admin/restart';
const API_ENDPOINT_V1_EXTRACT_ARTICLE                       = '/api/v1/extract-article';
const API_ENDPOINT_V1_GENERATE_HEADLINE                     = '/api/v1/generate-headline';
const API_ENDPOINT_V2_TAG                                   = '/api/v2/tag';
const API_ENDPOINT_V1_KB_QUERY                              = '/api/v1/kb-query';

const enrichLangSupport = {
    'coreferences': ['en'],
    'disambiguate': ['ar', 'de', 'en', 'es', 'fr', 'nl', 'ru', 'zh'],
    'textCorrections': ['en'],
    'geocodeStreets': ['ar', 'de', 'en', 'es', 'fr', 'nl', 'ru'],
    'topicVector': ['en', 'de', 'es', 'fr', 'nl'],
    'keyPhrases': ['en'],
    'entitySentiment': ['en'],
    'documentSentiment': ['en'],
    'relationships': ['en'],
    'entitySummarization': ['en', 'de', 'es', 'fr', 'nl'],
    'documentSummarization': ['en', 'de', 'es', 'fr', 'nl'],
    'sentenceSalience': ['en', 'de', 'es', 'fr', 'nl'],
    'salience': ['en', 'de', 'es', 'fr', 'nl']
}

const urlHandler = {
        API_ENDPOINT_V1_VERSION,
        API_ENDPOINT_V1_DOC_SENTIMENT,
        API_ENDPOINT_V1_TRIT_SENTIMENT,
        API_ENDPOINT_V1_CONVERT_DOC,
        API_ENDPOINT_V2_CONVERT_DOC,
        API_ENDPOINT_V1_IE_PROMPTS,
        API_ENDPOINT_V1_CORRECT_TEXT,
        API_ENDPOINT_V1_DETECT_LANGUAGE,
        API_ENDPOINT_V1_DETECT_LANGUAGES,
        API_ENDPOINT_V2_DETECT_LANGUAGE,
        API_ENDPOINT_V2_DETECT_LANGUAGES,
        API_ENDPOINT_V1_LOCATION_FINDER,
        API_ENDPOINT_V1_INFORMATION_EXTRACTION_PROMPTS,
        API_ENDPOINT_V1_EXTRACTION,
        API_ENDPOINT_V1_EXTRACTION_INSERT,
        API_ENDPOINT_V1_EXTRACTION_VALIDATE,
        API_ENDPOINT_V1_EXTRACTION_DELETE,
        API_ENDPOINT_V1_EXTRACTION_DELETE_ALL,
        API_ENDPOINT_V1_EXTRACTION_RETRIEVE,
        API_ENDPOINT_V1_REGEX,
        API_ENDPOINT_V1_REGEX_INSERT,
        API_ENDPOINT_V1_REGEX_VALIDATE,
        API_ENDPOINT_V1_REGEX_DELETE,
        API_ENDPOINT_V1_REGEX_DELETE_ALL,
        API_ENDPOINT_V1_REGEX_RETRIEVE,
        API_ENDPOINT_V1_QUERY_PARSER,
        API_ENDPOINT_V1_SUMMARIZE,
        API_ENDPOINT_V1_USAGE,
        API_ENDPOINT_V1_USERINFO,
        API_ENDPOINT_V1_INTEREST_AREAS,
        API_ENDPOINT_V1_TRANSLATE,
        API_ENDPOINT_V2_ENRICH,
        API_ENDPOINT_V2_ENTITIES,
        API_ENDPOINT_V1_ADMIN_HEALTH,
        API_ENDPOINT_V1_ADMIN_SYSINFO,
        API_ENDPOINT_V1_ADMIN_RESTART,
        API_ENDPOINT_V1_EXTRACT_ARTICLE,
        API_ENDPOINT_V1_GENERATE_HEADLINE,
        API_ENDPOINT_V2_TAG,
        API_ENDPOINT_V1_KB_QUERY,

        // Ids in FFT now can be 64-bit and longer than javascript can natively support (15 digits max). This
        // converts "id" fields in the JSON string from numbers to strings so they can be parsed 
        // succesfully by javascript without getting rounded.

        convertResponseIdsToString: (response) => {
            return response.replace(/(?:"id"\s*:\s*)([0-9]+)/g, function(match, token) {
                return match.replace(token, '"' + token + '"');
            });
        },

        sanitizeText: (text) => {
            try {
                var txt = JSON.parse('"' + text.trim().replace(/^("|')|("|')$/g, '') + '"')
                return txt;
            } catch(e) {
                return text;
            }
        },

        // type = 'enrich', Authorization etc, if not defined, pure get request with url
        // example tells function if it was coming from a specific example or a sandbox etc..
        // stated is a particular example, see apiDoc example 1 and 2
        // txt is a prop passed if coming from a sandbox or input
        // callback is used to set state if needed

        //sentimentModel,
        //salienceModel,
        //lc,
        //textCorrections,
        //gdm,
        //types,
        //publishDate,
        //context,
        //relationships,

        sendRequest: (type,
            example,
            stated,
            txt,
            options,
            callback,async=true) => {

            const host = window._FFT_webServiceUrl;

            var exampleQuery = type,
                response,
                url,
                request = new XMLHttpRequest()

            var sentimentModel = options && options.sentimentModel || null;
            var salienceModel = options && options.salienceModel || null;
            var summaryModel = options && options.summaryModel || null;
            var lc = options && options.lc || 'en';
            var textCorrections = options && options.textCorrections || null;
            var gdm = options && options.gdm || 'base';
            var types = options && options.types || ['*'];
            var publishDate = options && options.publishDate || null;
            var context = options && options.context || null;
            var informationExtractionPrompt = options && options.informationExtractionPrompt !== '-------' && 
                options.informationExtractionPrompt;
            var informationExtraction = options && options.informationExtraction || false;
            var relationships = options && 'relationships' in options ? options.relationships : false;
            var coreferences = options && 'coreferences' in options ? options.coreferences : false;
            var returnTranslation = options && 'returnTranslation' in options ? options.returnTranslation : false;
            var entitySummarization = options && 'entitySummarization' in options ? options.entitySummarization : false;
            var documentSummarization = options && 'documentSummarization' in options ? options.documentSummarization : false;
            var sentenceSalience = options && 'sentenceSalience' in options ? options.sentenceSalience : false;
            var geocodeStreets = options && 'geocodeStreets' in options ? options.geocodeStreets && (types.includes('GEO') || types.includes('*')) : false;
            var forceEnglish = options && 'forceEnglish' in options ? options.forceEnglish : true;
        
            url = host + apiPath + exampleQuery

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200 || request.status === 250)) {
                    response = JSON.parse(urlHandler.convertResponseIdsToString(request.responseText));
                    if(typeof(callback)==='function'){
                        callback(response, txt, request.status);
                    }
                }
                if(request.readyState === 4 && request.status !== 200 && request.status !== 250) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, txt, errStatus);
                }
            };

            if(exampleQuery === 'enrich'){

                let v2Url = host + apiV2Path + exampleQuery

                request.open('POST', v2Url, async);
                request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));

                let ex = {
                    'languageCode': lc,
                    'disambiguate': true,
                    'mentions': true,
                    'entities': ['*'],
                    'returnText': true
                }

                if (example === 'email1'){
                    ex['text'] = '..Assistant Executive Director for Communications e-mail at: [mediaoffice@energy.state.ca.us]. Information concerning the status of the project, as well as notices and other relevant documents...';
                }else if (example === 'email2'){
                    ex['text'] = '...Send e-mail to talk [at] alaskapublic [dot] org (comments may be read on air)...';
                }else if (example === 'sandbox'){
                    if (forceEnglish) {
                        ex['targetLanguage'] = 'en';
                    }
                    if(types.length || informationExtraction){
                        ex['entities'] = types.includes('OTHER') || informationExtraction ? ['*'] : types;
                    }
                    if (sentimentModel === 'none') {
                        ex['entitySentiment'] = false;
                        ex['documentSentiment'] = false;
                    } else {
                        if (enrichLangSupport['entitySentiment'].includes(lc)) {
                            ex['entitySentiment'] = true;
                            ex['documentSentiment'] = false;
                            ex['sentimentModel'] = sentimentModel || window._sentimentModel;
                        } else {
                            ex['entitySentiment'] = false;
                            ex['documentSentiment'] = false;
                        }
                    }
                    if (textCorrections && Array.isArray(textCorrections) && textCorrections.length > 0 && enrichLangSupport['textCorrections'].includes(lc)) {
                        ex['textCorrections'] = textCorrections;
                    }
                    ex['disambiguate'] = false;
                    if (enrichLangSupport['disambiguate'].includes(lc) || forceEnglish) {
                        ex['disambiguate'] = true;
                    }
                    if (context) {
                        ex['context'] = context;
                    }
                    ex['keyPhrases'] = false;
                    if (enrichLangSupport['keyPhrases'].includes(lc)) {
                        ex['keyPhrases'] = true;
                    }
                    if (gdm != 'base') {
                        ex['geoModules'] = [gdm];
                    }
                    if (publishDate) {
                        ex['publishDate'] = publishDate;
                    }
                    if (relationships && enrichLangSupport['relationships'].includes(lc)) {
                        ex['relationships'] = true;
                    }

                    if (enrichLangSupport['coreferences'].includes(lc)) {
                        ex['coreferences'] = coreferences;
                    }

                    ex['returnTranslatedText'] = returnTranslation;

                    if (enrichLangSupport['entitySummarization'].includes(lc) || forceEnglish) {
                        ex['entitySummarization'] = entitySummarization;
                        if (summaryModel) {
                            ex['summaryModel'] = summaryModel;
                        }
                    }
                    if (enrichLangSupport['documentSummarization'].includes(lc) || forceEnglish) {
                        ex['documentSummarization'] = documentSummarization;
                        if (summaryModel) {
                            ex['summaryModel'] = summaryModel;
                        }
                    }
                    if (enrichLangSupport['sentenceSalience'].includes(lc) || forceEnglish) {
                        ex['sentenceSalience'] = sentenceSalience;
                    }
                    if (enrichLangSupport['salience'].includes(lc) || forceEnglish) {
                        if (salienceModel) {
                            if (salienceModel === 'none') {
                                ex['sentenceSalience'] = false;
                            } else {
                                ex['salience'] = true; 
                                ex['salienceModel'] = salienceModel || 'News';
                            }
                        }
                    }
                    if (enrichLangSupport['topicVector'].includes(lc) || forceEnglish) {
                        ex['topicVector'] = true;
                        ex['topicModel'] = 'news';
                    }
                    if (enrichLangSupport['geocodeStreets'].includes(lc)) {
                        ex['geocodeStreets'] = geocodeStreets;
                    }
                    
                    if (informationExtraction) {
                        ex['convertedDoc'] = txt;
                        ex['informationExtraction'] = informationExtraction
                        if (informationExtractionPrompt){
                            ex['informationExtractionPrompt'] = informationExtractionPrompt
                        }
                    }
                    else {
                        ex['text'] = urlHandler.sanitizeText(txt);
                    }
                }else if(example === 'host1'){
                    ex['text'] = 'OnBroadway.com sells tickets for many plays, musicals, and other shows.';
                }else if(example === 'host2'){
                    ex['text'] = 'Full details of all certified products are available on the forum website at: http://www.homegridforum.org/content/pages.php?pg=certified_systems .';
                }else if(example === 'ip1'){
                    ex['text'] = '...can ping the servers over at qmachine-1 on 0x16.0x65.0xF1.0x99 or qmachine-2 on 026.0145.037.0231 or run locally on 127.0.0.1:8080 with the exception that...';
                }else if(example === 'ip2'){
                    ex['text'] = 'The IP 144. 0. 241. 198 has just been banned by Fail2Ban after 5 attempts.';
                }else if(example === 'twitter1'){
                    ex['text'] = 'I will not attend the meeting with @POTUS';
                }else if(example === 'date1'){
                    ex['text'] = '10:10 am';
                }else if(example === 'date2'){
                    ex['text'] = 'Wednesday, October 4, 2006 02:00 PM EDT';
                }else if(example === 'date3'){
                    ex['text'] = 'The meeting will be next Tuesday';
                    ex['publishDate'] = moment().format('YYYY-MM-DD');
                }else if(example === 'dateRange1'){
                    ex['text'] = 'June through July 2006';
                }else if(example === 'dateRange2'){
                    ex['text'] = '1980s';
                }else if(example === 'dateRange3'){
                    ex['text'] = 'The results are from last March';
                    ex['publishDate'] = moment().format('YYYY-MM-DD');
                }else if(example === 'money1'){
                    ex['text'] = '$38.38';
                }else if(example === 'money2'){
                    ex['text'] = '156 billion rubles';
                }else if(example === 'geo1'){
                    ex['text'] = 'Walmart is headquartered in Bentonville.';
                }else if(example === 'geo2'){
                    ex['text'] = 'With the fall of Mosul, the impending capture of Raqqa, and the confirmed death of its leader, Abu Bakr al-Baghdadi, ISIL’s days as a caliphate are numbered.';
                }else if(example === 'org1'){
                    ex['text'] = '.The Alabama Entrepreneurial Research Network at the University of Alabama has received a $50,000 grant from the U.S. Department of Agriculture&apos;s Delta Regional Authority...';
                }else if(example === 'org2'){
                    ex['text'] = 'A handful of companies, including Purdue Pharma,  Allergan (AGN) and Johnson & Johnson (JNJ), have been sued by the city of Seattle, WA related to OxyContin.';
                }else if(example === 'person1'){
                    ex['text'] = '...show Dr. Richard Stevenson presented Mr. Jay X Smith with a diagnosis..';
                }else if(example === 'person2'){
                    ex['text'] = '...Contacts: The Centre for Drug Research and Development (CDRD) Barry Gee Director,';
                }else if(example === 'persond'){
                    ex['text'] = 'Edward Snowden is "under the care of the Russian authorities" and can&apos;t leave Moscow&apos;s international airport without their consent...';
                }else if(example === 'phone1'){
                    ex['text'] = '...Toll Free: 800/659-0059 Kathleen A. Sauvé - Media Relations...';
                }else if(example === 'phone2'){
                    ex['text'] = '...contact Gary Laurence (XFD) at ext. 2-9670...';
                }else if(example === 'nationality1'){
                    // eslint-disable-next-line
                    ex['text'] = "Edward Snowden is under the care of the Russian authorities and can't leave Moscow's international airport without their consent, Ecuadorean President Rafael Correa has said in an interview telegraphing the slim and diminishing possibility that the National Security Agency leaker will end up in Ecuador. Russian President Vladimir Putin has distanced himself from the case since Snowden arrived in Russia last week. Cuban leader Fidel Castro praised Correa's rejection of US trade pressure, expressing his sympathies for the Ecuadorean leader in a Sunday editorial in the state press. - AP.";
                }else if(example === 'language1'){
                    // eslint-disable-next-line
                    ex['text'] = "Sarkhej Roza houses incomplete yet beautifully handwritten copies of the Quran, a manuscript of Hidaya, and a printed Quran with Persian and Urdu translations. Additionally, an old handwritten copy of the Quran, completed in 1649 in the elegant Naskh script, remains one of the site's treasured possessions.";
                }else if(example === 'stockticker1'){
                    // eslint-disable-next-line
                    ex['text'] = "VAALCO Energy, Inc. (NYSE: EGY) announced that it had received notification on November 30, 2016, from the New York Stock Exchange ('NYSE') that the Company's market capitalization had fallen below the NYSE's continued listing standard. VAALCO is considered below criteria established by the NYSE because the Company’s average market capitalization fell below $50 million over a trailing consecutive 30 trading-day period and its last reported stockholders’ equity was less than $50 million.";
                }else if(example === 'peas'){
                    ex['text'] = 'Give peas a chance? When it comes to guacamole, no way, says President Barack Obama. He dipped into the great guacamole debate Wednesday after The New York Times suggested adding fresh green peas to guacamole.';
                } else if(example === 'enrich1'){
                    ex['text'] = 'Donald Trump congratulates Uhuru Kenyatta on win. Trump congratulates the people of Kenya on the successful conclusion of elections, and President Uhuru Kenyatta on his re-election.';
                } else if(example == 'acronym1') { 
                    ex['text'] = 'Global supercomputer leader Cray Inc. today announced a comprehensive set of Artificial Intelligence (AI) products and programs that will empower customers to learn, start, and scale their deep learning (DL) initiatives. As AI and DL continue to transform entire industries and scientific disciplines, Cray is leveraging its supercomputing expertise, technologies, and best practices to advance DL adoption. ';
                } else if(example == 'thing1') {
                    ex['text'] = 'The front of both new phones look similar to Apple\'s iPhone X, with the screen engulfing nearly the entire phone.'
                } 
                else if(example == 'measurement1') {
                    ex['text'] = 'The chip is the first product to implement the full ITU-T G.hn specification with MIMO support and up to 80 MHz.';
                } 
                else if(example == 'measurement2') {
                    ex['text'] = 'The radio spectrum is the part of the electromagnetic spectrum with frequencies from 3 Hz to 3 THz.';
                } 
                else if(example == 'measurement3') {
                    ex['text'] = 'In terms of data, the euro zone registered a growth rate 0.2 percent on the quarter and of 1.2 percent on the year at the end of 2018.';
                }
                else if (example == 'position1') {
                    ex['text'] = 'My Company Promotes John Smith to President & CEO Also appoints Joe Johnson, MD, PhD as its Chairman of the Board of Directors Marietta, GA (PRWEB) June 30, 2016 My Company, Inc., a leading manufacturer of goods, today announced that John Smith, its current Chief Operating Officer, has been named President and Chief Executive Officer. Additionally, My Company announced the appointment of Jane Doe, MD, PhD, a current My Company Director, to be the Chairman of its Board of Directors. Mr. Smith assumes the CEO position from the company founder Jane Doe, who will continue with My Company as a key part of its leadership team, as Chairman of the Executive Committee.';
                }
                request.send(JSON.stringify(ex));
            }
            else if(exampleQuery === 'enrichv1'){

                let v1Url = host + apiPath + 'enrich';
                request.open('POST',v1Url, async);
                request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));

                let ex = {
                    'metadata': {
                       'documentId': 'doc-12345678',
                       'languageCode': 'en'
                    }
                }

                if(example == 'enrich1') {
                    ex['document'] = 'Donald Trump congratulates Uhuru Kenyatta on win. Trump congratulates the people of Kenya on the successful conclusion of elections, and President Uhuru Kenyatta on his re-election.';
                } 
                request.send(JSON.stringify(ex));
            }
            else if(exampleQuery === 'doc-sentiment'){

                request.open('POST', url, async);
                request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));

                if (example === 'sentiment1'){

                    let ex = {
                        'mediaType': 'blog',
                        'documentId': '234526234',
                        'languageCode': 'en',
                        'documentSentimentModel': 'news3',
                        'text': 'May be more genial than ingenious, but it gets the job done. Silence of the Lambs has excellent acting but a very depressing plot.'
                    }
                    request.send(JSON.stringify(ex));
                } else if (example === 'sentiment2'){

                    let ex = {
                        'documentSentimentModel': 'news3',
                        'text': 'The White House on Tuesday vigorously defended President Trump’s budget...'
                    }
                    request.send(JSON.stringify(ex));
                } else if (example === 'sandbox'){

                    let ex = {
                        'mediaType': 'blog',
                        'languageCode': 'en',
                        'documentSentimentModel': sentimentModel || window._sentimentModel,
                        'text': txt
                    }
                    request.send(JSON.stringify(ex));
                }
            }
            else if(exampleQuery === 'correct-text'){

                request.open('POST', url, async);
                request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));

                if (example === 'correct1'){
                    let ex = {
                        'text': 'donald trump congratulates President Uhuru Kenyatta on his re-election.',
                        'languageCode': 'en',
                        'textCorrections': ['case', 'punctuation'] 
                    }
                    request.send(JSON.stringify(ex));
                }
            }
            else if(exampleQuery === 'tag2'){

                let v2Url = host + apiV2Path + 'tag'
                request.open('POST', v2Url, async);
                request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
                
                if (example === 'tag2'){
                    let ex = {
                        'text': 'Allianz Trade predicts up to $135bn of combined lost global exports in 2025 and 2026 based on a ‘contained trade war’, where the US hikes tariffs against China to 25% on half of non-critical US imports and raises 5% tariffs on the rest of the world, excluding Canada, Mexico and critical goods.',
                        'tagModels': ['iptc'],
                        'languageCode': 'en',
                        'maxTags': 3,
                        'tagThresholdPositive': 0.2
                    }
                    request.send(JSON.stringify(ex));
                }
            }
            else if(exampleQuery === 'detect-language'){

                request.open('POST', url, async);
                request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));

                if (stated) {
                    let ex = {
                        'text': stated,
                    }
                    request.send(JSON.stringify(ex));                   
                } else if (example === 'detectlanguage1'){
                    let ex = {
                        'text': 'On Sunday night (Oct. 7), a SpaceX Falcon 9 rocket successfully launched the SAOCOM 1A Earth-observation satellite from Vandenberg Air Force Base on California\'s Central Coast.' 
                    }
                    request.send(JSON.stringify(ex));
                } else if (example === 'detectlanguage2'){
                    let ex = {
                        'text': 'On Sunday night (Oct. 7), a SpaceX Falcon 9 rocket successfully launched the SAOCOM 1A Earth-observation satellite from Vandenberg Air Force Base on California\'s Central Coast. GroenLinks grote winnaar in Utrecht GroenLinks is de grote winnaar in Utrecht. D\'estate il connubio tra tasso di umidità e temperature elevate, unito a infiltrazioni di aria fresca da nord-ovest può dare vita a rari ma intensi fenomeni temporaleschi; questa situazione si protrae fino al mese di ottobre, le cui infiltrazioni di aria via via più fresca incontrano un mare ancora molto caldo. Durante il resto dell\'anno si alternano periodi più asciutti a periodi moderatamente piovosi, con picchi massimi nei mesi di novembre, dicembre e aprile. Der Vertrag ist einer der Pariser Vorortverträge, die den Ersten Weltkrieg formal beendeten, und wurde zwischen Österreich und 27 alliierten und assoziierten Mitgliedern abgeschlossen. Zu den Signatarmächten zählten neben Österreich die USA.  Two of President Donald Trump\'s former rivals for the GOP White House nomination won Senate confirmation Thursday to join his administration. Retired neurosurgeon Ben Carson was confirmed as secretary of the Department of House and Urban  Development on a vote of 58-41.  GroenLinks grote winnaar in Utrecht GroenLinks is de grote winnaar in Utrecht. Volgens de exitpoll van Ipsos heeft een kwart van het Utrechtse electoraat op GroenLinks gestemd. Der Vertrag ist einer der Pariser Vorortverträge, die den Ersten Weltkrieg formal beendeten, und wurde zwischen Österreich und 27 alliierten und assoziierten Mitgliedern abgeschlossen. Zu den Signatarmächten zählten neben Österreich die USA.'
                    }
                    request.send(JSON.stringify(ex));
                }
            }
            else if(exampleQuery === 'detect-language2'){

                let v2Url = host + apiV2Path + 'detect-language'

                request.open('POST', v2Url, async);
                request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));

                if (stated) {
                    let ex = {
                        'text': stated,
                    }
                    request.send(JSON.stringify(ex));                   
                } else if (example === 'detectlanguage1'){
                    let ex = {
                        'text': 'У меня большая семья из шести человек: я, мама, папа, старшая сестра, бабушка и дедушка. Мы живем все вместе с собакой Бимом и кошкой Муркой в большом доме в деревне. Мой папа встает раньше всех, потому что ему рано на работу. Он работает доктором. Обычно бабушка готовит нам завтрак. Я обожаю овсяную кашу, а моя сестра Аня – блины.' 
                    }
                    request.send(JSON.stringify(ex));
                }
            }
            else if(exampleQuery === 'detect-languages'){

                request.open('POST', url, async);
                request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));

                if (stated) {
                    let ex = {
                        'text': stated,
                    }
                    request.send(JSON.stringify(ex));                   
                } else if (example === 'detectlanguages1'){
                    let ex = {
                        'text': 'On Sunday night (Oct. 7), a SpaceX Falcon 9 rocket successfully launched the SAOCOM 1A Earth-observation satellite from Vandenberg Air Force Base on California\'s Central Coast. GroenLinks grote winnaar in Utrecht GroenLinks is de grote winnaar in Utrecht. D\'estate il connubio tra tasso di umidità e temperature elevate, unito a infiltrazioni di aria fresca da nord-ovest può dare vita a rari ma intensi fenomeni temporaleschi; questa situazione si protrae fino al mese di ottobre, le cui infiltrazioni di aria via via più fresca incontrano un mare ancora molto caldo. Durante il resto dell\'anno si alternano periodi più asciutti a periodi moderatamente piovosi, con picchi massimi nei mesi di novembre, dicembre e aprile. Der Vertrag ist einer der Pariser Vorortverträge, die den Ersten Weltkrieg formal beendeten, und wurde zwischen Österreich und 27 alliierten und assoziierten Mitgliedern abgeschlossen. Zu den Signatarmächten zählten neben Österreich die USA.  Two of President Donald Trump\'s former rivals for the GOP White House nomination won Senate confirmation Thursday to join his administration. Retired neurosurgeon Ben Carson was confirmed as secretary of the Department of House and Urban  Development on a vote of 58-41.  GroenLinks grote winnaar in Utrecht GroenLinks is de grote winnaar in Utrecht. Volgens de exitpoll van Ipsos heeft een kwart van het Utrechtse electoraat op GroenLinks gestemd. Der Vertrag ist einer der Pariser Vorortverträge, die den Ersten Weltkrieg formal beendeten, und wurde zwischen Österreich und 27 alliierten und assoziierten Mitgliedern abgeschlossen. Zu den Signatarmächten zählten neben Österreich die USA.'
                    }
                    request.send(JSON.stringify(ex));
                }
            }
            else if(exampleQuery === 'detect-languages2'){

                let v2Url = host + apiV2Path + 'detect-languages'

                request.open('POST', v2Url, async);
                request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));

                if (stated) {
                    let ex = {
                        'text': stated,
                    }
                    request.send(JSON.stringify(ex));                   
                } else if (example === 'detectlanguages1'){
                    let ex = {
                        'text': 'On Sunday night (Oct. 7), a SpaceX Falcon 9 rocket successfully launched the SAOCOM 1A Earth-observation satellite from Vandenberg Air Force Base on California\'s Central Coast. GroenLinks grote winnaar in Utrecht GroenLinks is de grote winnaar in Utrecht. D\'estate il connubio tra tasso di umidità e temperature elevate, unito a infiltrazioni di aria fresca da nord-ovest può dare vita a rari ma intensi fenomeni temporaleschi; questa situazione si protrae fino al mese di ottobre, le cui infiltrazioni di aria via via più fresca incontrano un mare ancora molto caldo. Durante il resto dell\'anno si alternano periodi più asciutti a periodi moderatamente piovosi, con picchi massimi nei mesi di novembre, dicembre e aprile. Der Vertrag ist einer der Pariser Vorortverträge, die den Ersten Weltkrieg formal beendeten, und wurde zwischen Österreich und 27 alliierten und assoziierten Mitgliedern abgeschlossen. Zu den Signatarmächten zählten neben Österreich die USA.  Two of President Donald Trump\'s former rivals for the GOP White House nomination won Senate confirmation Thursday to join his administration. Retired neurosurgeon Ben Carson was confirmed as secretary of the Department of House and Urban  Development on a vote of 58-41.  GroenLinks grote winnaar in Utrecht GroenLinks is de grote winnaar in Utrecht. Volgens de exitpoll van Ipsos heeft een kwart van het Utrechtse electoraat op GroenLinks gestemd. Der Vertrag ist einer der Pariser Vorortverträge, die den Ersten Weltkrieg formal beendeten, und wurde zwischen Österreich und 27 alliierten und assoziierten Mitgliedern abgeschlossen. Zu den Signatarmächten zählten neben Österreich die USA.'
                    }
                    request.send(JSON.stringify(ex));
                }
            }
            else if(exampleQuery === 'translate'){

                request.open('POST', url, async);
                request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));

                if (stated) {
                    let ex = {
                        'text': stated,
                        'targetLanguage': 'en'
                    }
                    request.send(JSON.stringify(ex));                   
                } else if (example === 'translate1'){
                    let ex = {
                        'text': '我的弟弟叫罗宾，他十五岁了。他有一头长长的棕色头发和一双蓝色的眼睛。他看起来很像我。',
                        'targetLanguage': 'en'
                    }
                    request.send(JSON.stringify(ex));
                }
            }
            else if(exampleQuery === 'summarize'){

                request.open('POST', url, async);
                request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));

                if (stated) {
                    let ex = {
                        'text': stated,
                    }
                    request.send(JSON.stringify(ex));                   
                } else if (example === 'summarize1'){
                    let ex = {
                        'languageCode': 'en',
                        'summaryModel': 'News',
                        'text': 'The Dow dropped as many as 549 points, or 2%, on Tuesday after major US companies reported gloomy results and guidance. Disappointing numbers from Caterpillar and 3M reinforced ongoing concerns about how long blockbuster profits can last, especially given tariffs and rising costs.\nThe Dow was recently down about 400 points. The S&P 500 declined 1.8%, while the Nasdaq tumbled about 2.2%. The Nasdaq is at risk of closing in a technical correction -- a 10% decline from prior highs.\n\"Investors are skittish about whether we\'ve seen a peak in earnings,\" said Mark Luschini, chief market strategist at Janney Capital Management. \"It\'s a schizophrenic market environment where things that didn\'t matter suddenly do.\n\" It\'s been a scary month for investors. The Dow has plunged about 1,500 points, or 5.7%. That would be the index\'s steepest monthly percentage decline since August 2015, a period when China fears were front-and-center.\nOctober has been even worse for the Nasdaq. The index, down 9% this month, is on track for its worst month since November 2008 when it plummeted 11%. Tech stocks, once the bright spot in the market, continued to take the brunt of the selling on Tuesday. Netflix and Amazon slid about 3%, while Apple and Facebook declined 2%.\n\"The market is fragile,\" said Rich Guerrini, CEO of PNC Investments. \"But we\'re telling our investors to relax. We\'re in a correction. I think the market does have some legs left.\"\nThe VIX volatility index soared 16% on Tuesday. The CNN Business Fear & Greed Index slipped further into \"extreme fear.\" A month ago the gauge of market sentiment was flashing \"extreme greed.\"\nWall Street was also spooked by extreme turbulence in China, the epicenter of the trade war. The Shanghai Composite dropped 2.3% overnight. The sell-off wipes out a chunk of Monday\'s spike, the benchmark index\'s best day since March 2016.\nA number of large American companies with exposure to growing trade disputes reported their quarterly financial results Tuesday. Investors are worried that a slowing Chinese economy and an escalating trade war could pinch profits.\n\"The earnings are reflecting investors\' worst fears -- and it\'s exacerbating the selling,\" said Michael Arone, chief investment strategist at State Street Global Advisors.\n3M (MMM) shares plunged 8% after the maker of Post-it Notes reported a dip in sales and weaker-than-expected profits. Worse, the Dow component downgraded its earnings forecast for the year.\nCaterpillar (CAT), a closely-watched barometer of global growth, tumbled 9% as the maker of construction and mining equipment\'s record third-quarter profit was overshadowed by disappointing guidance. Caterpillar, also a member of the Dow, warned of \"higher material and freight costs, including tariffs.\"\nHarley-Davidson (HOG) shares lost 5% after posting a 13% plunge in US sales due to \"weakness\" in the market. It was Harley\'s biggest sales slump in eight years, Bloomberg News reported. The company, which plans to shift some manufacturing overseas in response to the threat of tariffs, also warned tariffs will increase costs by up to $48 million this year.\nThe results highlight lingering worries about whether the US economy and stock market can continue to grow rapidly.\n\"How long is this going to last?\" asked Luschini. \"Companies that only match earnings get punished. And ones that miss expectations get outright slayed.\"\nBut the news wasn\'t all gloom-and-doom from Corporate America. McDonald\'s shares spiked 7% after saying earnings and sales declined less than feared.\nUnited Technologies (UTX), another major global company, raised its outlook. And Verizon said it grew profit and revenue more than investors anticipated.\nOverall, Corporate America is still minting a ton of money thanks to the strong economy and tax cuts. S&P 500 companies are expected to grow per-share profits by nearly 20% this quarter, according to FactSet. And the vast majority of companies reporting results have beaten expectations.\nHowever, investors are bracing for a slowdown. S&P 500 profits are expected to decelerate to 16.5% in the fourth quarter and 6.8% in the second quarter, according to FactSet.\n\"Everyone sees that the rate of earnings growth is slowing. That becomes problematic,\" said State Street\'s Arone.\nGlobal growth concerns also weighted on the commodity markets. US oil prices tumbled nearly 3% to about $67.50 a barrel, pressuring energy stocks. Copper slid more than 1%.\nOverseas markets were sharply lower Tuesday. Hong Kong\'s Hang Seng index fell 3% in trading there, and Japan\'s Nikkei fell almost as much. The Dax in Germany was down 2%.'
                   }
                    request.send(JSON.stringify(ex));
                }
            }
            else if (exampleQuery === 'authenticate'){
                request.open('POST', url);
                request.setRequestHeader(API_AUTH_HEADER, stated);
                request.send();
            }
            else if(exampleQuery === 'personnel'){

                const queryURL = host + apiPath + 'kb-query/PERSON'

                const query = {
                    'search': {'index': {'name': 'EmployerIdsIdx','value': `${stated}`}},
                    'select': ['id', 'label','description','imageUrls[*]', 'citizenshipCountries[*]'],
                    'max-answers': 50
                }
                
                request.open('POST', queryURL, async);
                
                
                request.setRequestHeader('Content-Type', 'application/json');
                request.setRequestHeader('Accept', 'application/json');
                request.setRequestHeader('Authorization', 'Bearer ' + session.getToken());
                
                request.send(JSON.stringify(query));
                
            }
            else if(exampleQuery === 'extraction'){
                const queryURL = host + apiPath + 'extraction/retrieve'
                
                request.open('GET', queryURL, async);
                
                request.setRequestHeader('Content-Type', 'application/json');
                request.setRequestHeader('Accept', 'application/json');
                request.setRequestHeader('Authorization', 'Bearer ' + session.getToken());
                request.send();
            }
            else if(exampleQuery === 'regex'){
                const queryURL = host + apiPath + 'regex/retrieve'
                
                request.open('GET', queryURL, async);
                
                request.setRequestHeader('Content-Type', 'application/json');
                request.setRequestHeader('Accept', 'application/json');
                request.setRequestHeader('Authorization', 'Bearer ' + session.getToken());
                request.send();
            }
            else if (exampleQuery === 'entities') {
                if(stated[0] + stated[1] === 'un') {
                    // places do not have unique ids so return would have undefined/id;
                    return;
                }
                request.open('GET', url + '/' + stated, async);
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
                request.send();
            }
            else if (exampleQuery === 'entities2') {
                if(stated[0] + stated[1] === 'un') {
                    // places do not have unique ids so return would have undefined/id;
                    return;
                }

                let v2Url = host + apiV2Path + 'entities'

                request.open('GET', v2Url + '/' + stated, async);
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
                request.send();
            }
            else if (exampleQuery === 'searchByName') {
                request.open('GET', host + apiV2Path + 'entities/PERSON?query=Donald+Trump&maxAnswers=10&select=id,label,urls[*]', async);
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
                request.send();
            }
            else if (exampleQuery === 'kbInfo') {
                request.open('GET', host + apiV2Path + 'entities/PEOPLE', async);
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
                request.send();
            }
            else if (exampleQuery === 'kbInfoAll') {
                request.open('GET', host + apiV2Path + 'entities/info', async);
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
                request.send();
            }
            else if (exampleQuery === 'query-parser') {
                request.open('GET', url + '?' + stated);
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
                request.send();
            }
            else if (exampleQuery === 'location-finder') {
                request.open('GET', url + '?' + stated);
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
                request.send();
            }
            else if (exampleQuery === 'admin/sysinfo') {
                request.open('GET', url);
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
                request.send();
            }
            else if (exampleQuery === 'version') {
                request.open('GET', url);
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
                request.send();
            }
            else if (exampleQuery === 'userinfo') {
                request.open('GET', url);
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
                request.send();
            }
            else if (exampleQuery === 'interestareas') {
                request.open('GET', url);
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
                request.send();
            }
            else if (exampleQuery === 'extract-article') {
                request.open('GET', url + '?' + stated);
                request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
                request.send();
            }
        },
        convertDoc2: (text) => {
            return axios({
                method: 'post',
                url: '/extract2',
                timeout: 3600000,
                data: text,
                headers: {'X-Finch': 'Bearer ' + session.getToken()},
                signal: AbortSignal.timeout(3600000) //Aborts request after 5 seconds
              });
        }
        ,
        submitFeedback: (feedback) => {
            feedback.from = session.getUserName();
            feedback.id = Date.now();
            return axios.post('/feedback', feedback);
        },
        submitSentenceFeedback: (feedback) => {
            feedback.from = session.getUserName();
            feedback.id = Date.now();
            return axios.post('/sentencefeedback', feedback);
        },
        submitEntityFeedback: (feedback) => {
            feedback.from = session.getUserName();
            feedback.id = Date.now();
            return axios.post('/entityfeedback', feedback);
        },
        submitRelationshipFeedback: (feedback) => {
            feedback.from = session.getUserName();
            feedback.id = Date.now();
            return axios.post('/relationshipfeedback', feedback);
        },
        submitTagFeedback: (feedback) => {
            feedback.from = session.getUserName();
            feedback.id = Date.now();
            return axios.post('/tagfeedback', feedback);
        },
        submitSummaryFeedback: (feedback) => {
            feedback.from = session.getUserName();
            feedback.id = Date.now();
            return axios.post('/summaryfeedback', feedback);
        },
        // submitAccountRequest: (request) => {
        //     return axios.post('/requestaccount', request);
        // },
        // submitSupportRequest: (request) => {
        //     return axios.post('/requestsupport', request);
        // },
        // submitSalesRequest: (request) => {
        //     return axios.post('/requestsales', request);
        // },
        getUserPermissions: (callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'userinfo';
            
            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);
                    var perms = {};
                    if ('permissions' in jsonResp) {
                        perms = jsonResp['permissions'];
                    }    
                    callback(jsonResp, perms, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, {}, errStatus);
                }
            };

            request.open('GET', url);
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send();
        },
        getIETemplates: (callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'information-extraction-prompts';
            
            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);
                    var promptTemplates = [];
                    if ('promptTemplates' in jsonResp) {
                        promptTemplates = jsonResp['promptTemplates'];
                    }    
                    callback(jsonResp, promptTemplates, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, {}, errStatus);
                }
            };

            request.open('GET', url);
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send();
        },
        sendSummarizeRequest: (text, summaryModel, languageCode, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'summarize';
            
            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('POST', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));

            let ex = {summaryModel, languageCode, text: urlHandler.sanitizeText(text)}
            //let str = JSON.stringify(ex);
            //str = str.replace(/\\+/g, '\\');
            //request.send(str);     
            request.send(JSON.stringify(ex));
        },
        sendDocSentimentRequest: (text, documentSentimentModel, languageCode, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'doc-sentiment';
            
            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('POST', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));

            let ex = {documentSentimentModel, languageCode, text: urlHandler.sanitizeText(text)}
            request.send(JSON.stringify(ex));     
        },
        sendTagRequest: (text, tagModel, languageCode, posThreshold, negThreshold, maxTags, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiV2Path + 'tag';
            
            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('POST', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));

            let ex = {
                tagModels: [tagModel], 
                languageCode, 
                text: urlHandler.sanitizeText(text)
            };
            if (posThreshold) {
                ex.tagThresholdPositive = posThreshold;
            }
            if (negThreshold) {
                ex.tagThresholdNegative = negThreshold;
            }
            if (maxTags) {
                ex.maxTags = maxTags;
            }

            request.send(JSON.stringify(ex));     
        },
        sendKbQueryRequest: (name=null, id=null, kb, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = null;

            // HACK: This seems like a hack, but the query endpoints don't take the KB names, they
            // take the singular form, so we have to map them.
            var kbNames = {
                'PEOPLE': 'PERSON',
                'ORGANIZATIONS': 'ORGANIZATION',
                'THINGS': 'THING'
            }

            if (name) {
                if (kb === 'THINGS') {
                    url = host + apiV2Path + 'entities/' + kbNames[kb] + '?query=' + encodeURIComponent(name) + '&select=id,label,urls[*],type,description';
                } else {
                    url = host + apiV2Path + 'entities/' + kbNames[kb] + '?query=' + encodeURIComponent(name) + '&select=id,label,urls[*],type,description,permIds[*]';
                }
            } else if (id) {
                url = host + apiV2Path + 'entities/' + id;
            }

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = id ? JSON.parse('{"results":[{"document":' + request.responseText + '}]}') : JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };
            
            request.open('GET', url, async);
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send();     
        },
        sendKbInfoRequest: (kb, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiV2Path + 'entities/' + (kb ? kb : 'info');

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('GET', url, async);
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send();     
        },
        sendKbUpdateRequest: (id, data, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiV2Path + 'entities/' + id;

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('PUT', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send(JSON.stringify(data));    
        },
        sendCustomEntityCreateRequest: (data, callback, async=true) => {
            
            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();            
            const url = host + apiPath + 'extraction/insert'


            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.details;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };
            request.open('POST', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send(JSON.stringify({entries:[data]}));    
        },
        sendCustomEntityDeleteRequest: (data, callback, async=true) => {
            
            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();            
            const url = host + apiPath + 'extraction/delete'


            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };
            request.open('DELETE', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send(JSON.stringify({entries:data}));    
        },
        sendRegexCreateRequest: (data, callback, async=true) => {
            
            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();            
            const url = host + apiPath + 'regex/insert'


            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.details;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };
            request.open('POST', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send(JSON.stringify({entries:[data]}));    
        },
        sendRegexDeleteRequest: (data, callback, async=true) => {
            
            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();            
            const url = host + apiPath + 'regex/delete'


            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };
            request.open('DELETE', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send(JSON.stringify({entries:data}));    
        },
        sendKbCreateRequest: (type, data, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiV2Path + 'entities/' + type;

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('POST', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send(JSON.stringify(data));    
        },
        sendKbDeleteRequest: (id, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiV2Path + 'entities/' + id;

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('DELETE', url, async);
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send();    
        },
        sendUsageRequest: (begin, end, interval, level, user, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'usage';

            url += '?begin=' + begin;
            url += '&end=' + end;
            url += '&interval=' + interval;
            url += '&level=' + level;
            if (user) {
                url += '&user=' + user;
            }

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('GET', url, async);
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send();     
        },
        sendVersionRequest: (history, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'version';

            url += '?history=' + history;

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('GET', url, async);
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send();     
        },
        getInterestAreas: (callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'interest-areas';

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('GET', url, async);
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send();     
        },
        getInterestArea: (name, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'interest-areas/' + encodeURIComponent(name) + '?details=true';

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('GET', url, async);
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send();     
        },
        insertInterestAreaDocument: (name, title, model, orientation, text, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'interest-areas/' + encodeURIComponent(name) + '/' + encodeURIComponent(title);

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 201)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 201) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            var post_data = {
                tagModel: model,
                orientation,
                text
            }
            request.open('POST', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send(JSON.stringify(post_data));    
        },
        deleteInterestAreaDocument: (name, title, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'interest-areas/' + encodeURIComponent(name) + '/' + encodeURIComponent(title);

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 204)) {
                    var jsonResp = {};   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 204) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('DELETE', url, async);
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send();    
        },
        deleteInterestArea: (name, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'interest-areas/' + encodeURIComponent(name);

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 204)) {
                    var jsonResp = {};   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 204) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('DELETE', url, async);
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send();    
        },
        translateText: (sourceText, sourceFormat, targetLanguage, sourceLanguage, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'translate';

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            var post_data = {
                text: sourceText,
                targetLanguage,
            }
            if (sourceLanguage && sourceLanguage != 'auto') {
                post_data['sourceLanguage'] = sourceLanguage;
            }

            request.open('POST', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send(JSON.stringify(post_data));    
        },
        generateHeadline: (text, languageCode, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'generate-headline';

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            var post_data = {
                text,
                languageCode,
            }

            request.open('POST', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));
            request.send(JSON.stringify(post_data));    
        },
        authenticateGetProviders: (callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'providers';

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('GET', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.send();    
        },
        authenticateWithProvider: (protocol, provider, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + `authenticate?protocol=${protocol}`;

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            var post_data = {
                provider,
                callback_url: `${window.location.origin}/callback/${protocol}/${provider}`
            }

            request.open('POST', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.send(JSON.stringify(post_data));    
        },
        authenticateCallbackForProvider: (protocol, provider, code, state, callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + `${protocol}/callback/${provider}`;

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            var post_data = {
                code,
                provider,
                state
            }

            request.open('POST', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.send(JSON.stringify(post_data));    
        },
        authenticateRenewToken: (callback, async=true) => {

            const host = window._FFT_webServiceUrl;
            var request = new XMLHttpRequest();
            var url = host + apiPath + 'authenticate/renew';

            request.onreadystatechange = function () {
                if (request.readyState === 4 && (request.status === 200)) {
                    var jsonResp = JSON.parse(request.responseText);   
                    callback(jsonResp, request.status);
                }
                if(request.readyState === 4 && request.status !== 200) {
                    console.log('request.status = ' + request.status);
                    if (request.status === 401) {
                        session.end();
                    }

                    let errStatus = request.status;
                    if (request.status === 0) {
                        // If the status comes back as 0, something went wrong, but the XMLHttpRequest lib doesn't give 
                        // a specific http code, so just use the default.
                        errStatus = 500;
                    }
                    
                    var errMsg = 'undefined';
                    if (request.responseText) {
                        try {
                            var jsonResp = JSON.parse(request.responseText);                    
                            if ('message' in jsonResp) {
                                errMsg = jsonResp.message;
                            }
                        } catch(e) {
                            errMsg = request.responseText;
                        }
                    }

                    callback({
                        error_status: errStatus,
                        error_message: encodeURIComponent(errMsg)
                    }, errStatus);
                }
            };

            request.open('GET', url, async);
            request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            request.setRequestHeader(API_AUTH_HEADER, 'Bearer ' + encodeURIComponent(session.getToken()));  
            request.send();   
        },
}

export default urlHandler;
